import React, { Component } from 'react';

class Answer extends Component {
  constructor(props) {
    super(props);

    // Intentionally ignore prop updates: this component will only ever render
    // a single question during its lifecycle
    this.state = {
      answer: props.answers[props.currentQuestion],
      question: props.question
    };

    this.nextButton = React.createRef();
  }

  componentDidMount() {
    // Focus on the fieldset so the next tab will take user to first option
    this.nextButton.current.focus();
  }

  render() {
    let answerTitle = this.state.question
    .options[this.state.answer.answerIndex]
    .answerResultTitle;

    const answerBody = this.state.question
    .options[this.state.answer.answerIndex]
    .answerResultBody;

    const answerScore = this.state.question
    .options[this.state.answer.answerIndex]
    .score;

    const optionLabel = this.state.question.options[this.state.answer.answerIndex].answerText;

    // Get question colour
    const questionColour = this.state.question.questionColour.value;

    // Add a tick or cross to answer label
    // TODO: maybe there's a way that doesn't involve dangerously set inner HTML
    if(answerScore === "1") {
      answerTitle = `${answerTitle} <svg width="18" height="13" class="u-ml-1" xmlns="http://www.w3.org/2000/svg"><g fill="#FFF" fillR="nonzero"><path d="M2.071 5.656l5.657 5.657-1.414 1.414L.657 7.071z"/><path d="M4.95 11.263L16.264-.05l1.414 1.414L6.364 12.678z"/></g></svg>`
    } else {
      answerTitle = `${answerTitle} <svg width="13" height="13" class="u-ml-2 u-mt-1" xmlns="http://www.w3.org/2000/svg"><g fill="#FFF" fillR="nonzero"><path d="M1.364-.05l11.314 11.314-1.415 1.414L-.05 1.364z"/><path d="M-.05 11.263L11.264-.05l1.414 1.414L1.364 12.678z"/></g></svg>`
    }

    return (
      <div className="u-absolute u-pin-t u-pin-l u-p-4 u-w-full u-mt-0" ref={this.props.innerRef}>
        {/* Question number label */}
        <p className="u-pt-1/2 u-pb-1 u-px-2 u-inline-block u-w-auto u-bg-black u-text-white u-font-bold u-relative u-z-900">
          {/* Plus 1 for a 1-indexed number */}
          Answer {this.props.currentQuestion + 1} of {this.props.totalQuestions}
        </p>

        {/* Main answer body */}
        <div className={`u-border-solid u-border u-border-${questionColour}-500 u-p-6 sm:u-p-8 u--mt-3 u-clearfix`}>
          <div className="u-flex u-flex-col u-font-bold sm:u-flex-row">
            <p className={`u-pt-1/2 u-pb-1 u-px-4 u-bg-${questionColour}-500 u-text-white`}>{optionLabel}</p>
            <p className="u-pt-1/2 u-pb-1 u-px-2 u-mt-0 u-bg-black u-text-white u-flex u-items-center" dangerouslySetInnerHTML={{__html: answerTitle}} />
          </div>
          <p dangerouslySetInnerHTML={{__html: answerBody}} />

          <button type="button" onClick={this.props.goToNextQuestion} className={`button button--next button--white-text button--white button--quiz button--${questionColour}-bg u-mt-4 u-float-right`} ref={this.nextButton}>
            Next
          </button>
        </div>

      </div>
    );
  }
}

export default Answer;
